// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientsModale_container__1x5LW","col-2":"PatientsModale_col-2__4nXNH"};